import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Import the GoogleMapsProvider
// import { GoogleMapsProvider } from './utils/GoogleMapsLoader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wrap the entire app with GoogleMapsProvider to ensure Maps is initialized once */}
    {/* <GoogleMapsProvider> */}
      <App />
    {/* </GoogleMapsProvider> */}
  </React.StrictMode>
);
